/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import { DateTime } from 'luxon'
import ManagementReportListCard from '../management-reports/ManagementReportListCard'
import { useQuery } from '@tanstack/react-query'
import { fetchManagementReportYearsAvailable } from '../../lib/rest/managementReportAPIClient'
import LoadingHelper from '../../../../client/js/components/LoadingHelper'
import { parseNumber } from '@jalik/form-parser'
import { Container } from '@mantine/core'
import Page from '../../../../client/js/components/Page'
import LeaseBreadcrumb from './LeaseBreadcrumb'
import { useRouteLoaderData } from '../../../../client/js/components/RouteLoaderData'

function LeaseManagementReportListPage () {
  const intl = useIntl()
  const params = useParams<{ id: string }>()
  const leaseId = parseInt(params.id, 10)
  const lease = useRouteLoaderData<Lease>()

  const yearsQuery = useQuery({
    enabled: leaseId > 0,
    queryKey: ['leaseManagementReportYears', leaseId],
    queryFn: () => fetchManagementReportYearsAvailable({ leaseId }),
    refetchOnWindowFocus: false
  })

  const [searchParams, setSearchParams] = useQueryParams()

  const year =
    (typeof searchParams.year === 'string' ? parseNumber(searchParams.year) : null) ||
    yearsQuery.data?.data?.[0] ||
    DateTime.now().year

  const title = [
    intl.formatMessage({
      id: 'management_reports',
      defaultMessage: 'Rapports de gérance'
    }),
    year
  ].join(' ')

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <LeaseBreadcrumb
          lease={lease}
          title={title}
        />

        <LoadingHelper
          query={yearsQuery}
          render={() => (
            <ManagementReportListCard
              leaseId={leaseId}
              year={year}
              onYearChange={(value) => {
                setSearchParams((s) => ({ ...s, year: String(value) }))
              }}
            />
          )}
        />
      </Container>
    </Page>
  )
}

export default LeaseManagementReportListPage
